import React from "react";

const ColorModeContext = React.createContext({
    toggleColorMode: () => {},
    applyThemeChoice: (_) => {},
    themeChoice: 'auto',
    setPrimaryColorLight: (_) => {},
    setPrimaryColorDark: (_) => {},
    setAppLogoLight: (_) => {},
    setAppLogoDark: (_) => {},
    setAppLogoFavicon: (_) => {},
});

export default ColorModeContext;